import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import MobileDetect from "mobile-detect";
import React from "react";
import CentralNotificacoes from "./CentralNotificacoes/CentralNotificacoes";
import Chat from "./Chat/Chat";
import Onboarding from "./Onboarding/Onboarding";

const Factory = (props) => {

    switch (props.gerenciador) {
        case "chat": return (
            <Chat
                {...props}
            />
        );
        case "central-notificacoes": return (
            <CentralNotificacoes
                {...props}
            />
        );
        case "onboarding": return (
            <Onboarding
                {...props}
            />
        );
        default: return (
            <React.Fragment>

            </React.Fragment>
        );
    }
}


export default Factory;

